import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
var Breadcrumbs = function (_a) {
    var className = _a.className, breadcrumbs = _a.breadcrumbs;
    var theme = useTheme('TicketRequest').Breadcrumbs;
    return (React.createElement("div", { className: cn(theme.container, className) }, breadcrumbs.map(function (breadcrumb, index) { return (React.createElement("div", { className: cn(theme.item, breadcrumb.className), key: index }, breadcrumb.title)); })));
};
export default Breadcrumbs;
